module.exports = __webpack_public_path__ + "img/icon_gushumingmu_gaojing.1e51753a.svg";